var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "justify-content": "space-between",
        "align-items": "center"
      }
    },
    [
      _c(
        "cargo-advance-select",
        _vm._g(
          _vm._b(
            {
              staticStyle: { flex: "1" },
              attrs: {
                "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                "default-value": _vm.job.loadingPortCode
              },
              on: { parentCallBack: _vm.onParentCallBack }
            },
            "cargo-advance-select",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "el-checkbox",
        {
          staticStyle: { "padding-left": "2px" },
          on: {
            change: function($event) {
              return _vm.onChange("transfering")
            }
          },
          model: {
            value: _vm.job.transfering,
            callback: function($$v) {
              _vm.$set(_vm.job, "transfering", $$v)
            },
            expression: "job.transfering"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }